import React, { useEffect, useRef } from 'react';
import { FiClock } from 'react-icons/fi';
import { useWeeklyChallenge } from 'src/app/hooks/useWeeklyChallenge';
import { useClient } from 'jsonapi-react';
import { ChallengeCountdown, ChallengeCountdownBody, ChallengeCountdownContent, ChallengeCountdownHat, ChallengeCountdownHeader, ChallengeCountdownText, ChallengeCountdownTitle } from '@/components/custom/challenge';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Button, ButtonIcon } from '@/components/ui/button';
import toast from 'react-hot-toast';

export function WeekChallengeCountdown({ showQuestionCountDown }) {
  const { setCurrentStep, setStart, currentStep, setShowQuestionCountDown, questionCountDownTimer, setQuestionCountDownTimer, currentTaxonomy, currentChallenge, setCurrentAttempt, getQuestions } = useWeeklyChallenge();
  let intervalRef = useRef();

  const client = useClient();

  const createAttempt = async () => {
    const { data, error } = await client.mutate(`/challenges/${currentChallenge?.id}/challenge_attempt_items`);
    if (error) {
      toast.error('Erro ao criar uma tentativa');
    } else {
      setCurrentAttempt(data.id);
    }
  };

  useEffect(() => {
    if (showQuestionCountDown && currentStep === 1) {
      intervalRef.current = setInterval(() => {
        if (questionCountDownTimer > 0) setQuestionCountDownTimer(questionCountDownTimer - 1);
      }, 1000);

      return () => clearInterval(intervalRef.current);
    }
  }, [showQuestionCountDown, questionCountDownTimer]);

  useEffect(() => {
    if (showQuestionCountDown && currentStep === 1) {
      createAttempt();
      getQuestions();
    }
  }, [showQuestionCountDown, currentStep]);

  useEffect(() => {
    if (questionCountDownTimer === 0) {
      setShowQuestionCountDown(false);
      setCurrentStep(currentStep + 1);
      setStart(true);
    }
  }, [questionCountDownTimer]);

  useEffect(() => {
    setQuestionCountDownTimer(5);
  }, [currentTaxonomy]);

  if (!showQuestionCountDown) return null;

  return (
    <ChallengeCountdown>
      <ChallengeCountdownContent>
        <ChallengeCountdownHeader>
          <AvatarWrapper
            src={currentChallenge?.image}
            text="Foto do professor"
          />

          <ChallengeCountdownHat>Tema escolhido:</ChallengeCountdownHat>
          <ChallengeCountdownTitle>{currentTaxonomy?.name}</ChallengeCountdownTitle>
        </ChallengeCountdownHeader>

        <ChallengeCountdownBody>
          <ChallengeCountdownText>Prepare-se!</ChallengeCountdownText>

          <Button
            variant="outline"
            asChild
          >
            <span>
              <ButtonIcon>
                <FiClock />
              </ButtonIcon>{' '}
              00:0{questionCountDownTimer}
            </span>
          </Button>
        </ChallengeCountdownBody>
      </ChallengeCountdownContent>
    </ChallengeCountdown>
  );
}
